module.exports = __webpack_public_path__ + "static/media/arrow-head-white.ed17168e.svg";